import api from "../../../services/api";
import type { PeriodType } from "../hooks/useAccountingEcomm";


export const getEcommAccountingOverview = async (periodType: PeriodType) => {
  const response = await api.get(`/api/shopify/accounting/revenue_overview`, {
    params: { period_type: periodType },
  });
  return response.data.accounting_dashboard;
};
